import { selector } from 'lib/selectors';
import { PaymentProviderStatuses } from './helpers';

const paySettings = (state) => state.paySettings;
const paymentProvidersSelector = selector(paySettings, (p) => p.providers);

export const hasNonDisconnectedPaymentProviderSelector = selector(
  paymentProvidersSelector,
  (p) => !p.isEmpty() && p.some((provider) => provider.get('status') !== PaymentProviderStatuses.disconnected),
);

export const hasConnectedPaymentProviderSelector = selector(
  paymentProvidersSelector,
  (p) => !p.isEmpty() && p.some((provider) => provider.get('status') === PaymentProviderStatuses.connected),
);
